import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import React from "react";

const SwitchTitleDescription = ({
  title,
  description,
  value,
  onChange,
}: {
  title: string;
  description: string;
  value: boolean;
  onChange: (checked: boolean) => void;
}) => {
  return (
    <div className="flex flex-row w-full items-center justify-between">
      <div className="flex flex-col gap-1">
        <Label htmlFor={title} className="flex flex-col items-start">
          <span>{title}</span>
          <p className="text-xs text-muted-foreground">{description}</p>
        </Label>
      </div>
      <Switch id={title} checked={value} onCheckedChange={onChange} />
    </div>
  );
};

export default SwitchTitleDescription;
